var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.image)?_c('section',{staticClass:"max-full"},[_c('WpImage',{staticClass:"image",attrs:{"image":_vm.data.image,"size":"extra_large","background":"","cover":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }